export const getSelectedLocation = cityId => String(cityId);
